import {
  IMarketStatCollectionFilters,
  IMarketStatsBasePayload,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import { IMarketCategoryPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';

export const ALL_CATEGORY_ID = 'all';

export const isAllCategories = (categoryId: string) => categoryId === ALL_CATEGORY_ID;

export const initialStatsBasePayloadState: IMarketStatsBasePayload = {
  filter: {},
  isExtended: false,
};

export const initialStatsCollectionFiltersState: IMarketStatCollectionFilters = {
  search: '',
  sortBy: 'updatedAt',
  sortOrder: 'desc',
  page: 1,
  perPage: 25,
};

export const initialStatsData = {
  collection: [],
  totalCount: 0,
  payload: initialStatsBasePayloadState,
  collectionFilters: initialStatsCollectionFiltersState,
};

export const initialCategoriesPayloadState: IMarketCategoryPayload = {
  filters: {},
  isGrouped: false,
  sortBy: 'priority',
  sortOrder: 'asc',
};

export const initialCategoriesData = {
  categories: [],
  payload: initialCategoriesPayloadState,
};
